import { render } from "./NotFoundPage.vue?vue&type=template&id=e7ba183a&ts=true"
import script from "./NotFoundPage.vue?vue&type=script&lang=ts"
export * from "./NotFoundPage.vue?vue&type=script&lang=ts"

import "./NotFoundPage.vue?vue&type=style&index=0&id=e7ba183a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__